module.exports = "<h2 id=\"component-description\">Component Description</h2>\n<p>A Nessie NavDropdown is the parent container used to create dropdown menus inside a Nessie navigation bar, should be placed inside a Nessie NavItem.</p>\n<h2 id=\"example-usage\">Example Usage</h2>\n<pre><code>&lt;NavDropdown&gt;\n    &lt;NavItem isCurrentPage&gt;Home&lt;/NavItem&gt;\n    &lt;NavItem&gt;Somewhere else&lt;/NavItem&gt;\n&lt;/NavDropdown&gt;\n</code></pre>";


//////////////////
// WEBPACK FOOTER
// ./node_modules/html-loader!./node_modules/markdown-loader!./src/NavDropdown/README.md
// module id = 365
// module chunks = 0